module.exports = __webpack_public_path__ + "static/photo4-e211d7880148ddd5f165aacbf4181f3b.jpg";